import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { CONTACT } from 'config/contact';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Cookie Policy | Make Mind Automations</title>
        <meta
          name="description"
          content="Which cookies Make Mind Automations uses, what they do, and how you can manage them."
        />
        <link rel="canonical" href="https://makemindautomations.tech/cookies" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <main className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-bold text-text-primary mb-4">Cookie Policy</h1>
            <p className="text-text-secondary mb-10">Last updated: October 24, 2026</p>

            <div className="space-y-10 text-text-secondary leading-relaxed">
              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">What cookies are</h2>
                <p>
                  Cookies are small files stored on your device when you visit a website. They let
                  the site remember preferences and understand, in aggregate, how visitors use it.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Cookies we use</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <strong className="text-text-primary">Essential cookies:</strong> remember your
                    theme preference and keep forms working. The site needs these to function.
                  </li>
                  <li>
                    <strong className="text-text-primary">Analytics cookies:</strong> set via Google
                    Tag Manager to measure aggregate visits and popular pages. They do not identify
                    you personally.
                  </li>
                  <li>
                    <strong className="text-text-primary">Preference cookies:</strong> remember
                    choices such as display settings between visits.
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Managing cookies</h2>
                <p>
                  You can block or delete cookies in your browser settings. Blocking essential
                  cookies may affect how the site works, such as remembering your theme. Blocking
                  analytics cookies will not affect your use of the site.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Changes</h2>
                <p>
                  If we change the cookies we use, we will update this page and the date above.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Contact us</h2>
                <p>
                  Questions about cookies? Email us at{' '}
                  <a className="text-primary" href={`mailto:${CONTACT.email}`}>
                    {CONTACT.email}
                  </a>
                  .
                </p>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default CookiePolicy;
